import React, { useCallback, useState } from "react";
import { CloseIcon, UploadIcon } from "../../../../assets/icons/svgicons";
import styles from "./Upload.module.scss";
import { useDropzone } from "react-dropzone";

const Upload = ({ className, label, name, variant, image, setBlobImage }) => {
  const [uploadImage, setUploadImage] = useState(image);

  React.useEffect(() => {
    if (!image) {
      setUploadImage(null);
    }
  }, [image]);

  const onDrop = useCallback((acceptedFiles) => {
    setBlobImage(acceptedFiles[0]);
    let image = URL.createObjectURL(acceptedFiles[0]);
    setUploadImage(image);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      className={`${styles.upload} ${className || ""}`}
      data-variant={variant}
    >
      {label && <label htmlFor={name}>{label}</label>}
      {uploadImage ? (
        <div className={styles.prev_image}>
          <img src={uploadImage} alt="upload" />
          <button onClick={() => {
            setUploadImage(null);
            setBlobImage(null);
          }}>
            <CloseIcon />
          </button>
        </div>
      ) : (
        <div
          className={`${styles.upload_box} ${isDragActive ? styles.active : ""
            }`}
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <UploadIcon />
          <h6>Click here to upload image</h6>
          <p>SVG, PNG, JPG, JPEG(max. 500x500px)</p>
          <div className={styles.drag_box}>
            <h5>Upload...</h5>
          </div>
        </div>
      )}
    </div>
  );
};

export default Upload;
